//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from 'vuex';
import { Dialog } from 'element-ui';
import * as types from '@/types';
import PostItem from '@/components/list-items/post-item';
import { hotpostList, followList } from '@/api/hotpost';
import { sendDynamic, sendComment } from '@/api/index';
import commentTextarea from '@/components/public/comment/comment-textarea.vue';
import MessageDialog from '@/components/public/violation/message-dialog.vue';
import LogoBtn from '~/components/public/logo-btn.vue';
import noneData from '~/components/public/none-data.vue';
export default {
  components: {
    PostItem,
    LogoBtn,
    noneData,
    commentTextarea,
    MessageDialog,
    ElDialog: Dialog,
  },
  layout: 'bg-f6',
  async asyncData({ params, error, $axios }) {
    try {
      const type = params.type;
      let data = null;
      if (!type) {
        data = await $axios(
          hotpostList({
            page: 1,
            size: 20,
          })
        );
      } else if (type === 'follow') {
        data = await $axios(followList());
      }
      let version = null;
      let dataList = [];
      let hasMore = true;
      let timestamp = null;
      let loaded = null;
      if (data && data.result) {
        if (!type) {
          version = data.result.version;
          dataList = data.result.contents || [];
          if (dataList.length === 0) {
            hasMore = false;
          }
        } else if (type === 'follow') {
          dataList = data.result || [];
          loaded = dataList.length;
          dataList = dataList.filter(item => item.type !== 'suggestedUsers');
          if (dataList.length > 0) {
            timestamp = dataList[dataList.length - 1].data.createTimestamp;
          } else {
            hasMore = false;
          }
        }
      }
      return {
        dataList,
        version,
        hasMore,
        page: 1,
        pageType: type || '/',
        timestamp,
        loaded,
      };
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
      error({ statusCode: 404, message: '页面不存在' });
    }
  },
  data() {
    return {
      loading: false,
      defaultAvatar:
        'https://img4.gelonghui.com/headdefault/avatar_default2.png',
      messageData: {
        show: false,
        content: '',
      },
      replyId: null,
      showBtn: false,
      showDialog: false,
      type: 'dynamic', // dynamic | article
    };
  },
  computed: {
    ...mapGetters('user', ['isLogin', 'loginInfo']),
  },
  mounted() {
    if (this.isLogin) {
      this.defaultAvatar = this.loginInfo.avatar;
    }
    window.addEventListener('scroll', this.hanlder);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.hanlder);
  },
  methods: {
    ...mapMutations('user', {
      show: types.SHOW_LOGIN_FORM,
    }),
    hanlder(e) {
      const inputHeight =
        document.querySelector('.g-hotpost__input').clientHeight;
      const scrollHeight = document.documentElement.scrollTop;
      if (scrollHeight >= inputHeight + 21) {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    },
    /**
     * @description 显示发布动态的按钮
     */
    showSendDynamicBtn() {
      if (!this.isLogin) {
        this.show(false);
      } else {
        this.showDialog = true;
      }
    },
    /**
     * @description 点击动态的评论
     */
    clickComment(data) {
      this.type = data.type === 1 ? 'dynamic' : 'article';
      if (this.replyId === data.id) {
        this.replyId = null;
      } else {
        this.replyId = data.id;
      }
    },
    /**
     * @description 发送动态
     */
    async sendDynamicHandle(data) {
      const res = await this.$axios(
        sendDynamic({
          title: data.title,
          topicId: data.topic.topicId,
          content: data.content,
          pictureUrls: data.pictureUrls,
          refContents: data.refContents,
        })
      );
      if (res.statusCode === 200) {
        this.messageData.content = '已发布<br>内容审核中';
      } else {
        this.messageData.content = res.message;
      }
      this.messageData.show = true;
    },
    /**
     * @description 发送评论
     */
    async sendCommentHandle(data) {
      const res = await this.$axios(
        sendComment({
          source: this.type,
          refId: data.replyId,
          content: data.content,
          pictureUrls: data.pictureUrls,
          retweet: data.retweet,
        })
      );
      if (res.statusCode === 200) {
        this.dataList.some(item => {
          if (item.data.id === this.replyId) {
            item.data.comments = [];
            item.data.comments.push(res.result);
            return true;
          }
          return false;
        });
        this.messageData.content = '已发布<br>内容审核中';
      } else if (res.statusCode === 417) {
        this.messageData.content = '当前内容审核中无法评论';
      } else {
        this.messageData.content = res.message;
      }
      this.messageData.show = true;
    },
    closeMessage() {
      this.messageData.show = false;
      this.replyId = null;
      this.showDialog = false;
    },
    async getList() {
      let data = null;
      let dataList = this.dataList;
      this.loading = true;
      if (this.pageType === '/') {
        const page = this.page + 1;
        data = await this.$axios(
          hotpostList({
            page,
            size: 20,
            version: this.version,
          })
        );
      } else if (this.pageType === 'follow') {
        data = await this.$axios(
          followList({
            loaded: this.loaded,
            timestamp: this.timestamp,
          })
        );
      }
      if (data && data.result) {
        if (this.pageType === '/') {
          const arr = data.result.contents || [];
          if (arr.length === 0) {
            this.hasMore = false;
          }
          if (data.result.version === this.version) {
            dataList = dataList.concat(arr);
          } else {
            this.version = data.result.version;
            dataList = arr;
            document.body.scrollTop = 0;
          }
          this.page = data.result.page;
        } else if (this.pageType === 'follow') {
          let arr = data.result || [];
          const loaded = arr.length;
          arr = arr.filter(item => item.type !== 'suggestedUsers');
          if (loaded > 0) {
            dataList = dataList.concat(arr);
            this.loaded = this.loaded + loaded;
            this.timestamp = arr[arr.length - 1].data.createTimestamp;
          } else {
            this.hasMore = false;
          }
        }
        this.dataList = dataList;
        this.loading = false;
      }
    },
    /**
     * @description 动态删除事件
     */
    handleDelete(index) {
      this.dataList.splice(index, 1);
    },
  },
};
